<template>
    <b-container fluid>
        <h1 class="mt-4 mb-4">Closed Orders</h1>

        <div v-if="noOrders">
            <p>You don't have any closed orders.</p>
        </div>
        <Table class="table" v-if="items.length>0" :items="items" :fields="fields" :hasDeleteButton="true"/>

        <loader v-else :class="{ hidden: noOrders }"/>
  </b-container>
</template>

<script>
import Loader from "../../components/Loader"
import { db } from '@/main'
import firebase from 'firebase'
import axios from 'axios'
import Table from "@/components/Table.vue";
export default {
    components: {
        Table,
        Loader
    },
    data() {
        return {
            items: [],
            fields: [
                { key: 'closedTime', sortable: true },
                { key: 'startTime', sortable: true },
                { key: 'customer', sortable: true },
                { key: 'tags', sortable: true },
                { key: 'note', sortable: false },
                { key: 'status', sortable: false },
                // { key: 'notify', sortable: false },
                { key: 'options', sortable: false },
            ],
            noOrders: false
        }
    },

    async created() {
        const userDoc = await db.collection('users').doc(firebase.auth().currentUser.uid).onSnapshot(async(doc) => {
            const business = doc.data().business;
            const plan = doc.data().plan;
            const trialVar = doc.data().trialTextsFinished;
            if ((trialVar ==1) && (plan == 'trial')) {
                vueInstance.$router.push({path: '/subscription'});
            }


            const snapshot = await firebase.firestore().collection('businesses').doc(business).collection('orders').where('orderObj.status', '==', 'closed')
            .onSnapshot(querySnapshot => {
                const openArray = querySnapshot.docs.map(doc => doc.data().orderObj);
                querySnapshot.forEach(doc => {
                })
                this.items = openArray;
                if (this.items.length==0) {
                    this.noOrders = true;
                }
            });
        });
    },
}
</script>

<style scoped>
.hidden {
  visibility: hidden !important;
  /* transition: all 0.5s ease; */
}

.table {
    margin-top: 55px;
}
</style>
